import { useEffect, useState } from 'react';

interface UseImpressionOptions extends IntersectionObserverInit {
  triggerOnce?: boolean;
  rootMargin?: string;
  threshold?: number;
}

export const useImpression = (ref: any, options: UseImpressionOptions = {}) => {
  const { rootMargin = '0px', threshold = 0.8, triggerOnce = true } = options;

  const [hasTriggered, setHasTriggered] = useState(false);

  useEffect(() => {
    if (!ref) {
      return;
    }
    const element = ref.current;
    if (!element || (triggerOnce && hasTriggered)) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (triggerOnce) {
            setHasTriggered(true);
            observer.unobserve(element);
          }
        }
      },
      { rootMargin, threshold }
    );

    observer.observe(element);

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [ref, rootMargin, threshold, triggerOnce, hasTriggered]);

  return hasTriggered;
};
